// JsFromRoutes CacheKey 0c813600cc03bf096e0c00f361672154
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  retriggerRecoupment: /* #__PURE__ */ definePathHelper('post', '/admin/members/:member_id/retrigger_recoupment'),
  submitUnitApplication: /* #__PURE__ */ definePathHelper('post', '/admin/members/:member_id/submit_unit_application'),
  freezeUnitAccount: /* #__PURE__ */ definePathHelper('post', '/admin/members/:member_id/freeze_unit_account'),
  unfreezeUnitAccount: /* #__PURE__ */ definePathHelper('post', '/admin/members/:member_id/unfreeze_unit_account'),
  freezeUnitCards: /* #__PURE__ */ definePathHelper('post', '/admin/members/:member_id/freeze_unit_cards'),
  unfreezeUnitCards: /* #__PURE__ */ definePathHelper('post', '/admin/members/:member_id/unfreeze_unit_cards'),
  toggleSupportMode: /* #__PURE__ */ definePathHelper('patch', '/admin/members/:member_id/toggle_support'),
  updateConfigurableOptions: /* #__PURE__ */ definePathHelper('patch', '/admin/members/:member_id/update_configurable_options'),
  deletePlaidAccount: /* #__PURE__ */ definePathHelper('delete', '/admin/members/:id/delete_plaid_account'),
  index: /* #__PURE__ */ definePathHelper('get', '/admin/members'),
  edit: /* #__PURE__ */ definePathHelper('get', '/admin/members/:id/edit'),
  show: /* #__PURE__ */ definePathHelper('get', '/admin/members/:id'),
  update: /* #__PURE__ */ definePathHelper('patch', '/admin/members/:id'),
}
